import { Component, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { ISalonDetailsApi } from '@app/salon-details/models/salon-details-api.model';
import { smoothScrollToElementId } from '@app/shared/utils';

@Component({
  selector: 'app-reviews-header',
  templateUrl: './reviews-header.component.html',
  styleUrls: ['./reviews-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewsHeaderComponent {
  @HostBinding('class') cssClass: string;
  salonDetails: ISalonDetailsApi;

  scrollToReviews(reviewsContainerId: string): void {
    smoothScrollToElementId(reviewsContainerId, 500, 100);
  }
}

